export const actionCreator = (type) => (payload) => ({
  type,
  ...(payload !== undefined ? { payload } : {}),
});

export const addDomainEntity = (state, entity) => {
  if (entity.id) {
    state[entity.id] = entity;
  }

  return state;
};
export const addDomainEntityId = (state, entity) => {
  if (entity.id) {
    state.push(Number(entity.id));
  }

  return state;
};
